import React from "react";
import InvoicesPrint from "../AFReadyDisigen/InvoicesPrint";
export default function RevMaintainceInv(props) {
    return (
        <div>
            <InvoicesPrint  typeInv={3} />
        </div>
    );
}